import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type IPaymentSourceType } from "./types";

/**
 * Initial state
 * sourceTypeId: string;
  sourceType: "salesAndPromotion" | "referral" | "direct";
  sourceCode: string;
  discountedPrice: number;
  actualPrice: number;
 */
const initialState: IPaymentSourceType = {
  isValid: false,
  sourceTypeId: null,
  sourceType: "direct",
  sourceCode: null,
  discount: null,
  discountedPrice: null,
  originalPrice: 20,
};

const paymentSourceTypeSlice = createSlice({
  name: "paymentSourceType",
  initialState,
  reducers: {
    setPaymentSourceType: (
      state,
      action: PayloadAction<IPaymentSourceType>,
    ) => {
      state.sourceTypeId = action.payload.sourceTypeId;
      state.sourceType = action.payload.sourceType;
      state.sourceCode = action.payload.sourceCode;
      state.discountedPrice = action.payload.discountedPrice;
      state.originalPrice = action.payload.originalPrice;
      state.discount = action.payload.discount;
    },
    resetPaymentSourceType: (state) => {
      state.sourceTypeId = null;
      state.sourceType = "direct";
      state.sourceCode = null;
      state.discountedPrice = null;
      state.discount = null;
    },
  },
});

// Export actions
export const { setPaymentSourceType, resetPaymentSourceType } =
  paymentSourceTypeSlice.actions;
export default paymentSourceTypeSlice.reducer;
